const CHAR_LIMIT = 2000;

export function initContactModal(): void {
  const overlay = document.getElementById('contactModal') as HTMLElement;
  const closeBtn = document.getElementById('contactModalClose') as HTMLButtonElement;
  const form = document.getElementById('contactForm') as HTMLFormElement;
  const subjectInput = document.getElementById('contactSubject') as HTMLInputElement;
  const messageInput = document.getElementById('contactMessage') as HTMLTextAreaElement;
  const charsLeft = document.getElementById('contactCharsLeft') as HTMLElement;
  const errorMsg = document.getElementById('contactErrorMsg') as HTMLElement;
  const successMsg = document.getElementById('contactSuccessMsg') as HTMLElement;
  const submitBtn = document.getElementById('contactSubmitBtn') as HTMLButtonElement;
  const contactBtn = document.getElementById('contactBtn') as HTMLButtonElement;

  if (!overlay || !form) return;

  function openModal(): void {
    overlay.style.display = 'flex';
    subjectInput.value = '';
    messageInput.value = '';
    charsLeft.textContent = String(CHAR_LIMIT);
    errorMsg.style.display = 'none';
    successMsg.style.display = 'none';
    submitBtn.disabled = false;
    subjectInput.focus();
  }

  function closeModal(): void {
    overlay.style.display = 'none';
    // Close the user dropdown too
    document.getElementById('userDropdown')?.classList.remove('open');
  }

  contactBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    closeModal(); // close dropdown first
    openModal();
  });

  closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
  });

  messageInput.addEventListener('input', () => {
    const remaining = CHAR_LIMIT - messageInput.value.length;
    charsLeft.textContent = String(Math.max(0, remaining));
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const subject = subjectInput.value.trim();
    const message = messageInput.value.trim();

    errorMsg.style.display = 'none';
    successMsg.style.display = 'none';

    if (!subject) {
      errorMsg.textContent = 'Please enter a subject.';
      errorMsg.style.display = 'block';
      subjectInput.focus();
      return;
    }

    if (!message) {
      errorMsg.textContent = 'Please enter a message.';
      errorMsg.style.display = 'block';
      messageInput.focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subject, message }),
      });

      if (res.ok) {
        successMsg.style.display = 'block';
        subjectInput.value = '';
        messageInput.value = '';
        charsLeft.textContent = String(CHAR_LIMIT);
        setTimeout(closeModal, 1800);
      } else {
        const data = await res.json() as { error?: string };
        errorMsg.textContent = data.error ?? 'Something went wrong. Please try again.';
        errorMsg.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send';
      }
    } catch {
      errorMsg.textContent = 'Network error. Please try again.';
      errorMsg.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send';
    }
  });
}
